<template>
	<el-dialog :title='title' :visible.sync="dialogVisible" width="30%" :before-close='close'
		:close-on-click-modal='false'>
    <el-alert v-if="info.delay_time"
        :title="`该公司已设定延迟至${info.delay_time}上传业务清单！`"
        :closable="false"
        type="error">
      </el-alert>
		<el-form ref='refformData' :model="formData" label-position="right" label-width="120px">
			<el-form-item label="上传日期设定" required>
        <el-date-picker
          :picker-options="pickerOptions"
          v-model="formData.delay_time"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

			<el-form-item>
				<el-button type='primary' @click="saveFun">保存</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
	export default {
		props:{
      title: {
        type: String,
        default: ''
      }
    },
		components: {
			
		},
		data() {
			return {
        pickerOptions:{
          disabledDate:time => {
            return  (time?.getTime() < new Date(this.info?.default_upload_time.replace(/[年月日]/g,  "/")).getTime() || time?.getTime() <= new Date().getTime())
          }
        },
        info:{},
        disabledDate:true,
				dialogVisible: false,
				formData: {
					delay_time:''
				},
			}
		},
		
		methods: {
			open(item) {
				this.dialogVisible = true;
        this.info = item;
        if(this.info?.delay_time){
          this.formData.delay_time = this.info?.delay_time.replace(/[年月日]/g, function (x) {
            if(x=='日'){
              return '';
            }
            return '-'
          })
        }else{
          this.formData.delay_time = this.info?.default_upload_time.replace(/[年月日]/g, function (x) {
            if(x=='日'){
              return '';
            }
            return '-'
          })
        }
        console.log(this.formData.delay_time)
			},
			close(done) {
				this.resetForm()
				this.$emit('refresh')
				done && done()
				this.dialogVisible = false
			},
      
			async saveFun() {
				for (let key in this.formData) {
					if(!this.formData[key]){
						this.$message({
							message: `请填写必填项`,
							type: 'warning'
						});
						return
					}
					
				}
				let res = await this.$api.postDelayBillUplate(this.info.id,this.formData)
				if (res) {
					this.$message({
						message: `添加成功`,
						type: 'success'
					});
					this.close()
				}
			},
      
			//重置表单
			resetForm() {
				this.formData = {
					delay_time: ''
				}
			},
		},
		
		mounted() {
		},
	}
</script>

<style lang="scss" scoped>
	.el-select{
		display: block;
	}
  
  .el-alert{
    margin-bottom: 20px;
  }
</style>
